import { useTranslation } from 'react-i18next';

// Also referenced in apps/landing (the LP "Try free" CTA). Keep in sync if the URL changes.
const CONTACT_URL = 'https://spacemusic-ai.soundraw.io/#contact';

interface Props {
  alreadyUsed: boolean;
}

export default function TrialEndModal({ alreadyUsed }: Props) {
  const { t } = useTranslation();
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/70 backdrop-blur-sm">
      <div
        className="rounded-2xl p-8 flex flex-col items-center gap-5 text-center max-w-md mx-4"
        style={{ background: 'rgba(4,11,19,0.98)', border: '1px solid rgba(255,251,147,0.3)' }}
      >
        <div
          className="w-16 h-16 rounded-full flex items-center justify-center"
          style={{ background: 'linear-gradient(135deg, #FFFB93, #ffa064)' }}
        >
          <svg className="w-8 h-8 text-[#040B13]" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" />
          </svg>
        </div>
        <div>
          <p className="text-white font-bold text-xl mb-2">{t('trialEndTitle')}</p>
          <p className="text-gray-300 text-sm leading-relaxed">
            {alreadyUsed ? t('trialAlreadyUsedMessage') : t('trialEndMessage')}
          </p>
        </div>
        <a
          href={CONTACT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="px-6 py-3 rounded-full font-bold text-[#040B13]"
          style={{ background: '#FFFB93' }}
        >
          {t('trialContactButton')}
        </a>
      </div>
    </div>
  );
}
